<div class="d-flex justify-content-between" style="background-color: #f3f2f7;">
    <div class="col-4 my-auto">
        <a (click)="redirectIndex()">
            <img class="imagen" src="https://back.in-mo.app/INMOAPP_LOGO_2022_2.png" alt="brand-logo" />
        </a>
    </div>

    <div class=" col-4 my-auto d-flex justify-content-end">
        <div class="p-1 my-auto">
            <div class="gb">
                <a style="color: #1A7DB6; margin-right: 10px;" target="_blank" href="https://inmoapp.mx/"> Publica tus
                    propiedades </a>
                <button type="button" class="btn btn-primary btn-sm" rippleEffect (click)="redirectLogin()">
                    <i data-feather="user" class="mr-0 mr-sm-1"></i>
                    <span class="d-none d-sm-inline-block">Login</span>
                </button>
            </div>

            <div class="btn-group hsm">
                <div ngbDropdown>
                    <button ngbDropdownToggle class="btn btn-primary btn-sm" type="button" id="dropdownMenuButton"
                        rippleEffect>
                        <i data-feather="user" class="mr-0 mr-sm-1"></i>
                        <span class="d-none d-sm-inline-block">Login</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                        <a ngbDropdownItem (click)="redirectLogin()">Login</a>
                        <a ngbDropdownItem (click)="register()">Publica tus propiedades</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>